import { ShortIdsByProject } from '@neptune/shared/entity-domain';
import { makeEntityIdentifier } from '@neptune/shared/entity-util';

export const fromShortIdsByProjectToExperimentIds = (shortIdsByProject: ShortIdsByProject) =>
  Array.from(shortIdsByProject.entries()).flatMap(([projectId, ids]) =>
    ids.map((id) => id && makeEntityIdentifier(projectId, id)).filter(Boolean),
  );
